import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import axios from 'axios'
import VueAxios from 'vue-axios' // 追記
// bootstrapの実装
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

Vue.use(IconsPlugin)
Vue.use(BootstrapVue)
Vue.config.productionTip = false

const axiosBase = require('axios')
const axiosMainFunc = axiosBase.create({
  baseURL: 'https://asia-northeast1-k-log-helth-vue.cloudfunctions.net', // バックエンドB のURL:port を指定する
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  },
  responseType: 'json'
})

Vue.use(VueAxios, axiosMainFunc, axios) // 追記

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
